var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCategory82X(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 8@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BaoRider-application-(PWA)",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tasks",
    transform: "translate(-22.000000, -549.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(0.000000, 96.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(22.000000, 453.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    fill: "#2C6734"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 20,
    cy: 20,
    r: 20
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shape-2",
    transform: "translate(9.000000, 9.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8392857,5.30514286 L19.8392857,3.64728571 L13.9307143,3.64728571 C13.4977857,3.64728571 13.145,3.29371429 13.145,2.86157143 C13.145,2.42942857 13.4977857,2.07585714 13.9307143,2.07585714 L19.8102143,2.07585714 C19.6687857,0.909857143 18.6842857,-6.51796077e-13 17.4813571,-6.51796077e-13 L4.51785714,-6.51796077e-13 C3.31492857,-6.51796077e-13 2.33042857,0.909857143 2.189,2.07585714 L8.03785714,2.07585714 C8.47,2.07585714 8.82357143,2.42942857 8.82357143,2.86157143 C8.82357143,3.29371429 8.47,3.64728571 8.03785714,3.64728571 L2.16071429,3.64728571 L2.16071429,5.30514286 C0.953857143,5.4065 0,6.40907143 0,7.64185714 L0,17.8545714 C0,20.0207857 1.76235714,21.7831429 3.92857143,21.7831429 L18.0714286,21.7831429 C20.2376429,21.7831429 22,20.0207857 22,17.8545714 L22,7.64185714 C22,6.40907143 21.0461429,5.4065 19.8392857,5.30514286 Z M10.2637857,2.07507143 L11.7047857,2.07507143 C12.1392857,2.07507143 12.4905,2.42707143 12.4905,2.86078571 C12.4905,3.2945 12.1392857,3.6465 11.7047857,3.6465 L10.2637857,3.6465 C9.82928571,3.6465 9.47807143,3.2945 9.47807143,2.86078571 C9.47807143,2.42707143 9.83007143,2.07507143 10.2637857,2.07507143 Z M10.9842857,19.6907857 C7.61435714,19.6907857 4.87221429,16.9486429 4.87221429,13.5779286 C4.87221429,10.208 7.61435714,7.46664286 10.9842857,7.46664286 C14.3542143,7.46664286 17.0963573,10.208 17.0963573,13.5779286 C17.0971429,16.9486429 14.355,19.6907857 10.9842857,19.6907857 Z M15.0173571,12.507 L15.0173571,14.6496429 C15.0173571,15.0464286 14.6967857,15.3685714 14.2992143,15.3685714 L12.8047857,15.3685714 L12.8047857,16.8355 C12.8047857,17.2322857 12.4834286,17.5536429 12.0858571,17.5536429 L9.91414286,17.5536429 C9.51657143,17.5536429 9.19521429,17.2322857 9.19521429,16.8355 L9.19521429,15.3685714 L7.70078571,15.3685714 C7.30321429,15.3685714 6.98264286,15.0464286 6.98264286,14.6496429 L6.98264286,12.507 C6.98264286,12.1117857 7.30321429,11.7888571 7.70078571,11.7888571 L9.19521429,11.7888571 L9.19521429,10.3227143 C9.19521429,9.92592857 9.51657143,9.60457143 9.91414286,9.60457143 L12.0858571,9.60457143 C12.4834286,9.60457143 12.8047857,9.92592857 12.8047857,10.3227143 L12.8047857,11.7888571 L14.2992143,11.7888571 C14.6967857,11.7888571 15.0173571,12.1117857 15.0173571,12.507 Z",
    id: "Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategory82X);
export default __webpack_public_path__ + "static/media/Category 8@2x.920a779bc13fdecaba466753eb0747a8.svg";
export { ForwardRef as ReactComponent };